<template>
  <modal :active="active" @close="handleCloseModal">
    <div
      class="col-12"
      style="
        display: flex;
        justify-content: space-around;
        height: 250px;
        align-items: center;
      "
    >
      <div
        class="col-5"
        style="
          display: flex;
          align-items: center;
          flex-direction: column;
          margin: 0;
          justify-content: center;
        "
      >
        <p
          style="
            margin: 0px;
            margin-bottom: 5px;
            font-weight: bold;
            font-size: 26px;
          "
        >
          NEW CONTRACT
        </p>
        <p style="margin: 0px; font-size: 18px; padding-top: 25px">
          Create a new contract
        </p>
      </div>
      <div
        v-if="contractType == 'InvestorContract'"
        class="col-7"
        style="display: flex; justify-content: center"
      >
        <div class="col-6">
          <button
            class="btn btn-success"
            @click="redirectToCreateInvestor()"
            type="button"
            style="padding: 10px; width: 100%"
          >
            New Investor
          </button>
        </div>

        <div class="col-6">
          <button
            class="btn btn-warning"
            @click="redirectToCreateInvestorContract()"
            type="button"
            style="padding: 10px; color: white; width: 100%"
          >
            Existing Investor
          </button>
        </div>
      </div>
      <div
        v-else-if="contractType == 'ProjectContract'"
        class="col-7"
        style="display: flex; justify-content: center"
      >
        <div class="col-6">
          <button
            class="btn btn-success"
            @click="redirectToCreateProject()"
            type="button"
            style="padding: 10px; width: 100%"
          >
            New Project
          </button>
        </div>

        <div class="col-6">
          <button
            class="btn btn-warning"
            @click="redirectToCreateProjectContract()"
            type="button"
            style="padding: 10px; color: white; width: 100%"
          >
            Existing Project
          </button>
        </div>
      </div>
    </div>
  </modal>
</template> 
 <script>
import Spinner from "vue-simple-spinner";
import Modal from "../../../../components/Modal.vue";
import { mapState } from "vuex";
export default {
  props: {
    active: Boolean,
    actionType: String,
    activeContract: Object,
    contractType: String,
  },
  components: { Spinner, Modal },
  created: function () {},
  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
    }),
  },
  methods: {
    redirectToCreateInvestor() {
      this.$router.push(
        "/" + this.authUser.userable_type + "/investors/create"
      );
    },
    redirectToCreateProject() {
      this.$router.push("/" + this.authUser.userable_type + "/projects/create");
    },
    redirectToCreateInvestorContract() {
      this.$router.push(
        "/" + this.authUser.userable_type + "/investors/contracts/create"
      );
    },
    redirectToCreateProjectContract() {
      this.$router.push(
        "/" + this.authUser.userable_type + "/projects/contracts/create"
      );
    },
    handleCloseModal() {
      this.$emit("closeRequest");
    },
  },
};
</script> 
 <style>
.modal-header {
  border-bottom: none !important;
}
.modal-footer {
  border-top: none !important;
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/components/modals/contractModal.vue